'use client';

import type { PropsWithChildren } from 'react';
import type { DehydratedState } from 'react-query';
import { Hydrate } from 'react-query';

type Props = {
  state: DehydratedState;
};

export function HydrateClient({ children, state }: PropsWithChildren<Props>) {
  return <Hydrate state={state}>{children}</Hydrate>;
}
